enum TipoTemplateEnum {
    HoraLetiva = 1,
    ReservaCargaHoraria,
    ListaAtividade,
    CentroResultado,
    HoraNaoLetivaFlutuante,
    Estudantes,
    AprovadoresPlanoAtividade,
    ContratoProfessores,
    AtividadesEsporadicas,
    HoraExtra,
    HistoricoCargaHoraria,
}

const TipoTemplateEnumLabel = new Map<TipoTemplateEnum, string>([
    [TipoTemplateEnum.HoraLetiva, "Hora Letiva"],
    [TipoTemplateEnum.ReservaCargaHoraria, "Reserva Carga Horária"],
    [TipoTemplateEnum.ListaAtividade, "Atividade Não Letiva"],
    [TipoTemplateEnum.CentroResultado, "Centro de Resultado"],
    [
        TipoTemplateEnum.HoraNaoLetivaFlutuante,
        "Hora Não Letiva - Matriz Curricular",
    ],
    [TipoTemplateEnum.Estudantes, "Estudante"],
    [
        TipoTemplateEnum.AprovadoresPlanoAtividade,
        "Aprovador TACH (Coordenador)",
    ],
    [TipoTemplateEnum.ContratoProfessores, "Contrato Professor (Docente)"],
    [TipoTemplateEnum.AtividadesEsporadicas, "Atividades Esporádicas"],
    [TipoTemplateEnum.HoraExtra, "Hora Letiva RE"],
    [TipoTemplateEnum.HistoricoCargaHoraria, "Histórico de Carga Horária"],
]);

const TipoTemplateEnumList = () => {
    return Array.from(TipoTemplateEnumLabel).map((item: any) => {
        return {
            value: item["0"],
            text: item["1"],
        };
    });
};

export { TipoTemplateEnum, TipoTemplateEnumLabel, TipoTemplateEnumList };
